//RENAME THIS FILE ONCE WE KNOW MORE OF WHICH FUNCTIONS ARE HOSTED HERE
export const SAVE_BOOKING_FORM = "SAVE_BOOKING_FORM";
export const SAVED_BOOKING_FORM = "SAVED_BOOKING_FORM";

export const GET_EXISTING_BOOKING = "GET_EXISTING_BOOKING";
export const GOT_EXISTING_BOOKING = "GOT_EXISTING_BOOKING";

export const GET_SIBBLING_BOOKING = "GET_SIBBLING_BOOKING";
export const GOT_SIBBLING_BOOKING = "GOT_SIBBLING_BOOKING";

export const SAVE_CREDIT_CARD = "SAVE_CREDIT_CARD";
export const SAVED_CREDIT_CARD = "SAVED_CREDIT_CARD";

export const CHARGE_MONEY_TO_CREDIT_CARD = "CHARGE_MONEY_TO_CREDIT_CARD";
export const CHARGED_MONEY_TO_CREDIT_CARD = "CHARGED_MONEY_TO_CREDIT_CARD";

export const GOT_STRIPE_TOKEN = "GOT_STRIPE_TOKEN";
export const GET_STRIPE_TOKEN = "GET_STRIPE_TOKEN";

export const UPDATE_BOOKING_FORM = "UPDATE_BOOKING_FORM";

export const ERROR_SAVING_BOOKING_FORM = "ERROR_SAVING_BOOKING_FORM";

export const GET_UPDATED_TOKEN = "GET_UPDATED_TOKEN";
export const GOT_UPDATED_TOKEN = "GOT_UPDATED_TOKEN";

export const GET_BOOKING_PRINTABLE_VERSION = "GET_BOOKING_PRINTABLE_VERSION";
export const GOT_BOOKING_PRINTABLE_VERSION = "GOT_BOOKING_PRINTABLE_VERSION";

export const SENT_BOOKING_EMAIL = "SENT_BOOKING_EMAIL";
export const SEND_BOOKING_EMAIL = "SEND_BOOKING_EMAIL";

export const GET_PURCHASED_OFFER = "GET_PURCHASED_OFFER";
export const GOT_PURCHASED_OFFER = "GOT_PURCHASED_OFFER";

export const REMOVE_OFFER_FROM_FORM = "REMOVE_OFFER_FROM_FORM";

export const SPLIT_RECURRING_APPOINTMENT = "SPLIT_RECURRING_APPOINTMENT";

export const saveBooking = (
  appointmentStepData,
  advancedAppointmentStepData,
  status,
  applyto,
  cb,
  isMultiServiceAppointment,
  gotValidOffer
) => {
  return {
    type: SAVE_BOOKING_FORM,
    data: {
      appointmentStepData,
      advancedAppointmentStepData,
      status,
      applyto,
      cb,
      isMultiServiceAppointment,
      gotValidOffer
    }
  };
};

export const updateBooking = (
  appointmentStepData,
  advancedAppointmentStepData,
  currentBookingId,
  status,
  applyto,
  cb,
  isMultiServiceAppointment,
  gotValidOffer,
  oldStartTime = null,
  advancedAppointmentStepDataBeforeUserHasMadeAnyChanges
) => {
  return {
    type: UPDATE_BOOKING_FORM,
    data: {
      appointmentStepData,
      advancedAppointmentStepData,
      currentBookingId,
      status,
      applyto,
      cb,
      isMultiServiceAppointment,
      gotValidOffer,
      oldStartTime,
      advancedAppointmentStepDataBeforeUserHasMadeAnyChanges
    }
  };
};

export const splitRecurringAppointment = (
  currentBookingId,
  oldStartTime,
  cb,
  recurrence,
  dateTimeOfFirstAppointmentInRecurringSeries
) => {
  return {
    type: SPLIT_RECURRING_APPOINTMENT,
    data: {
      currentBookingId,
      oldStartTime,
      cb,
      recurrence,
      dateTimeOfFirstAppointmentInRecurringSeries
    }
  };
};

export const getExistingBooking = payload => {
  return {
    type: GET_EXISTING_BOOKING,
    payload
  };
};

export const removeOfferFromForm = () => {
  return {
    type: REMOVE_OFFER_FROM_FORM
  };
};

export function loadCachedExistingBooking(cachedData) {
  return {
    type: GOT_EXISTING_BOOKING,
    data: cachedData
  };
}

export const saveCreditCard = payload => {
  return {
    type: SAVE_CREDIT_CARD,
    payload
  };
};

export const gotStripeToken = stripeToken => {
  return {
    type: GOT_STRIPE_TOKEN,
    stripeToken
  };
};

export const getStripeToken = () => {
  return {
    type: GET_STRIPE_TOKEN
  };
};

export const getUpdatedToken = () => {
  return {
    type: GET_UPDATED_TOKEN
  };
};

export const getBookingPrintableVersion = bookingId => {
  return {
    type: GET_BOOKING_PRINTABLE_VERSION,
    bookingId
  };
};

export const sendBookingEmail = (
  currentBookingId,
  selectedAppointmentStatusId,
  applyto,
  starttime,
  cb,
  oldStartTime = null,
  advancedAppointmentStepDataBeforeUserHasMadeAnyChanges
) => {
  return {
    type: SEND_BOOKING_EMAIL,
    data: {
      currentBookingId,
      selectedAppointmentStatusId,
      applyto,
      starttime,
      cb,
      oldStartTime,
      advancedAppointmentStepDataBeforeUserHasMadeAnyChanges
    }
  };
};

export const getSibblingBooking = payload => {
  return {
    type: GET_SIBBLING_BOOKING,
    payload
  };
};

export const getPurchasedOffer = offerId => {
  return {
    type: GET_PURCHASED_OFFER,
    offerId
  };
};
